import gql from "graphql-tag";


export const acceptTVCode = gql`mutation Mutation($userId: String!, $code: String!) {
  acceptTVCode(userID: $userId, code: $code) {
    success
    error
    message
    code
  }
}`